<template>
  <keep-alive>
    <router-view/>
  </keep-alive>
</template>

<script setup>
import {ref, watch} from 'vue'
import {useRoute} from "vue-router";
import store from "@/store";
import router from "@/router";
import axios from "axios";

const route = useRoute()


watch(route, (to, from) => {
  console.log(to.name, to.path)
  if (window.sessionStorage.getItem('currentUser') === null) {
    console.log("没有用户")
    router.replace("/login")
  }
  if (to.name === '个人中心') {
    let obj = {
      name: to.name,
      path: to.path
    }
    store.commit('ADD_TABS', obj)
  }
}, {deep: true, immediate: true})
</script>

<style>
html, body, #app {
  height: 100%;
}

.app-container {
  padding: 20px;
  background-color: white;
}
</style>
